import React from 'react'
import { Typography, Alert } from '@paintscout/ui'
import type { PresentationHelpProps } from '../../'

export default function Help({ ..._props }: PresentationHelpProps) {
  return (
    <Alert severity="info">
      <Typography>Add links to PDF documents for your customers to access.</Typography>
      <Typography>We'll show a thumbnail of your document - along with a link to view the full PDF.</Typography>
    </Alert>
  )
}
